/**
 * Checked Colors Mixin for Notebook Tab Components
 *
 * Provides reactive color filtering state for notebook tabs that display
 * selections filtered by highlighter color slugs.
 *
 * Handles:
 * - Initializing `checkedColors` with all available highlighter slugs on mount (own + shared)
 * - Automatically syncing `checkedColors` when highlighters are added or removed
 *
 * Requirements:
 * - The consuming component must map the `allHighlighters` getter and `sharedColors` state from the store.
 *
 * @example
 * import { mapGetters, mapState } from 'vuex';
 * import checkedColorsMixin from '_shared_/js/mixins/checkedColorsMixin';
 *
 * export default {
 *     mixins: [checkedColorsMixin],
 *     computed: {
 *         ...mapState(['sharedColors']),
 *         ...mapGetters(['allHighlighters']),
 *     },
 * };
 */
export default {
    data() {
        return {
            checkedColors: [],
        };
    },
    computed: {
        /**
         * All color slugs available (own + shared).
         */
        allAvailableSlugs() {
            const ownSlugs = this.allHighlighters.map(h => h.slug);
            const sharedSlugs = (this.sharedColors || []).map(h => h.slug);
            return [...ownSlugs, ...sharedSlugs];
        },
    },
    watch: {
        allAvailableSlugs(newSlugs) {
            const prunedCheckedColors = this.checkedColors.filter(slug => newSlugs.includes(slug));
            const newSlugsToAdd = newSlugs.filter(slug => !prunedCheckedColors.includes(slug));
            this.checkedColors = [...prunedCheckedColors, ...newSlugsToAdd];
        },
    },
    mounted() {
        this.checkedColors = this.allAvailableSlugs;
    },
};
